const locationIncludes = path => (process.browser ? window.location.href.toLowerCase().includes(`/${path}`) : false);

const unlocalizePath = path => path.replace(/^(https?:\/\/)?([^\/]*)(\/[a-zA-Z]{2}[\/\?]?)([\/\?].*)?$/, `$1$2$4`);

export { locationIncludes, unlocalizePath };
